import { FunctionComponent } from "react";

export interface Props {
  className?: string;
}

const SimpleLogo: FunctionComponent<Props> = ({ className }) => {
  return (
    <svg
      width="245"
      height="66"
      viewBox="0 0 245 66"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M213.047 65.5386C193.725 65.5386 181.527 53.6071 181.527 33.1276V32.9495C181.527 12.4701 193.725 0.538574 213.047 0.538574C232.369 0.538574 244.568 12.4701 244.568 32.9495V33.1276C244.568 53.6071 232.369 65.5386 213.047 65.5386ZM213.047 50.2235C216.876 50.2235 218.835 46.8399 218.835 33.1276V32.9495C218.835 19.2372 216.876 15.8536 213.047 15.8536C209.219 15.8536 207.26 19.2372 207.26 32.9495V33.1276C207.26 46.8399 209.219 50.2235 213.047 50.2235Z"
        fill="currentColor"
      />
      <path
        d="M159.403 64.203L158.246 56.5454C155.663 62.6002 150.232 65.5386 142.307 65.5386C127.794 65.5386 116.485 55.566 116.485 33.1276V32.9495C116.485 13.4495 127.615 0.538574 148.362 0.538574C166.526 0.538574 175.252 7.75091 176.855 20.5728L155.129 22.5317C154.684 17.9906 152.458 15.8536 149.074 15.8536C144.088 15.8536 142.218 18.792 142.218 32.9495V33.1276C142.218 47.7304 143.999 50.7578 148.985 50.7578C152.191 50.7578 154.595 48.2646 154.595 43.8125V42.3879H147.026V27.7852H177.211V64.203H159.403Z"
        fill="currentColor"
      />
      <path
        d="M81.399 65.5386C62.077 65.5386 49.8784 53.6071 49.8784 33.1276V32.9495C49.8784 12.4701 62.077 0.538574 81.399 0.538574C100.721 0.538574 112.92 12.4701 112.92 32.9495V33.1276C112.92 53.6071 100.721 65.5386 81.399 65.5386ZM81.399 50.2235C85.2277 50.2235 87.1866 46.8399 87.1866 33.1276V32.9495C87.1866 19.2372 85.2277 15.8536 81.399 15.8536C77.5702 15.8536 75.6113 19.2372 75.6113 32.9495V33.1276C75.6113 46.8399 77.5702 50.2235 81.399 50.2235Z"
        fill="currentColor"
      />
      <path
        d="M0 64.2028V1.87402H24.6644V46.3946H48.2603V64.2028H0Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default SimpleLogo;
